/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Home_Nav_CompareInputs */

const en_gc_home_nav_compare = /** @type {(inputs: Gc_Home_Nav_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft vs Excel`)
};

const zh_gc_home_nav_compare = /** @type {(inputs: Gc_Home_Nav_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比 Excel`)
};

/**
* | output |
* | --- |
* | "GridCraft vs Excel" |
*
* @param {Gc_Home_Nav_CompareInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_home_nav_compare = /** @type {((inputs?: Gc_Home_Nav_CompareInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Home_Nav_CompareInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_home_nav_compare(inputs)
	return zh_gc_home_nav_compare(inputs)
});
export { gc_home_nav_compare as "gc.home.nav.compare" }